import { defineComponent as u, computed as p, createElementBlock as a, openBlock as s, createVNode as d, createElementVNode as t, createCommentVNode as o, renderSlot as l, createBlock as b, toDisplayString as i, unref as m, createTextVNode as g } from "vue";
import { RevTag as v } from "@ds/components/Tag";
import h from "../../icons/generated/IconEyeOpen.vue2.js";
import { useLocale as _ } from "@ds/plugin";
import y from "./components/MessageAvatar.vue2.js";
const k = { class: "flex flex-row gap-12" }, w = { class: "grow" }, $ = { class: "mb-4 flex flex-col justify-center" }, x = { class: "flex items-center justify-between gap-8" }, N = { class: "flex shrink grow-0 flex-col overflow-hidden sm:flex-row sm:gap-8" }, V = ["title"], B = {
  key: 0,
  class: "text-static-default-low body-1 shrink-0 grow basis-[7ch] self-start text-right md:self-end"
}, D = {
  key: 0,
  class: "text-static-default-low body-2-bold mt-4 flex items-center gap-4"
}, T = { class: "body-1 mb-16 whitespace-pre-line break-words" }, j = {
  key: 0,
  class: "mb-16 grid grid-cols-1 gap-16 lg:grid-cols-3"
}, F = /* @__PURE__ */ u({
  name: "RevMessage",
  __name: "Message",
  props: {
    variant: {},
    label: {},
    tag: {},
    timestamp: {},
    visibility: {}
  },
  setup(c) {
    const r = c, f = _(), n = p(() => r.timestamp && Intl.DateTimeFormat(f.value, {
      hour: "2-digit",
      minute: "2-digit"
    }).format(r.timestamp));
    return (e, z) => (s(), a("article", k, [
      d(y, {
        class: "mt-4 shrink-0",
        label: e.label,
        variant: e.variant
      }, null, 8, ["label", "variant"]),
      t("div", w, [
        t("div", $, [
          t("div", x, [
            t("div", N, [
              t("div", {
                class: "text-static-default-hi body-1-bold truncate",
                title: e.label
              }, i(e.label), 9, V),
              e.tag ? (s(), b(m(v), {
                key: 0,
                class: "ml-0 mr-auto mt-2",
                label: e.tag,
                size: "medium",
                variant: "secondary"
              }, null, 8, ["label"])) : o("", !0)
            ]),
            n.value ? (s(), a("time", B, i(n.value), 1)) : o("", !0)
          ]),
          e.visibility ? (s(), a("div", D, [
            d(m(h), { size: "20" }),
            g(i(e.visibility), 1)
          ])) : o("", !0)
        ]),
        t("div", T, [
          l(e.$slots, "default")
        ]),
        e.$slots.documents ? (s(), a("div", j, [
          l(e.$slots, "documents")
        ])) : o("", !0),
        l(e.$slots, "appendix")
      ])
    ]));
  }
});
export {
  F as default
};
